import { render, staticRenderFns } from "./V7IndikasiTercatatGabungan.vue?vue&type=template&id=7b98592a&"
import script from "./V7IndikasiTercatatGabungan.vue?vue&type=script&lang=js&"
export * from "./V7IndikasiTercatatGabungan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports